import { type ActionCreator, on, type ReducerTypes } from '@ngrx/store';
import { produce } from 'immer';

import { type EngineStateBase } from '@blaze-runtime/engine-data-access';

import { getPathLastInSlot } from '../../utils/layout/helpers';
import { placeElementMutably } from '../../utils/layout/place-element';

import { placeCopiedElements } from './copy-paste.actions';

export const copyPasteReducerTypes: ReducerTypes<EngineStateBase, ActionCreator[]>[] = [
  on(
    placeCopiedElements,
    (state, { rootElementId, newContainer, elements, connections, workflows, dialogs, slotId }) =>
      produce(state, (draft: EngineStateBase) => {
        const path = getPathLastInSlot(state, newContainer.id, slotId ?? '0');

        for (const element of elements) {
          draft.entities[element.id] = element;
          (draft.ids as string[]).push(element.id);
        }

        draft.connections.push(...connections);
        draft.workflows.push(...workflows);
        draft.pages.push(...dialogs);
        placeElementMutably(draft, { elementId: rootElementId, atPath: path });

        return draft;
      }),
  ),
];
